import googleProtobufStructPb from "google-protobuf/google/protobuf/struct_pb.js"

import { frontendProxy } from "../../configs"
import { NotifyRequest } from "../proto/integratedapp_pb"

export default class AuthAPI {
  /**
   * Initialize the Auth API
   */
  constructor(jwt = "") {
    // attach metadata
    if (jwt) {
      this.baseMetadata = {
        authorization: `Bearer ${jwt}`,
        "x-proxy-cluster": "auth"
      }
    }

    if (process.server) {
      // server
      const { IntegratedAppsClient } = require("../proto/integratedapp_grpc_pb")

      this.client = new IntegratedAppsClient(
        "auth:50001",
        require("@grpc/grpc-js").credentials.createInsecure()
      )
    } else {
      // web
      const {
        IntegratedAppsClient
      } = require("../proto/integratedapp_grpc_web_pb")

      this.client = new IntegratedAppsClient(frontendProxy)
    }
  }

  /**
   * Generic notify request to auth service
   *
   * @param {string} operationKey - endpoint identifier
   * @param {Object} payload - payload object
   * @returns
   */
  notify(operationKey, payload) {
    // make request to auth service to
    // generate custom token
    const self = this

    return new Promise((resolve, reject) => {
      // define callback
      const cb = (err, res) => {
        err ? reject(err) : resolve(res.getPayload().toJavaScript())
      }

      // set request
      const request = new NotifyRequest()

      // set operation type
      request.setOperationKey(operationKey)

      // set payload if provided
      if (Object.keys(payload || {}).length) {
        request.setPayload(
          googleProtobufStructPb.Struct.fromJavaScript(payload)
        )
      }

      let arg2, arg3
      if (process.server) {
        arg2 = cb
        arg3 = undefined
      } else {
        arg2 = this.baseMetadata || {}
        arg3 = cb
      }

      self.client.notify(request, arg2, arg3)
    })
  }

  // /**
  //  * Generate custom token for the user id
  //  */
  // generateCustomToken(userId, jwt) {
  //   // make request to auth service to
  //   // generate custom token
  //   const self = this

  //   return new Promise((resolve, reject) => {
  //     // define callback
  //     const cb = (err, res) => {
  //       console.log("err", err, "res", res, res.__proto__)
  //       err ? reject(err) : resolve(res)
  //     }

  //     // set request
  //     const request = new CustomTokenRequest()
  //     request.setUserId(userId)

  //     let arg2, arg3
  //     if (process.server) {
  //       arg2 = cb
  //       arg3 = undefined
  //     } else {
  //       arg2 = {
  //         authorization: `Bearer ${jwt}`
  //       }
  //       arg3 = cb
  //     }

  //     self.client.generateCustomToken(request, arg2, arg3)
  //   })
  // }

  // /**
  //  * Verify the ID Token.
  //  *
  //  * @param {string} token - ID Token
  //  */
  // verifyIdToken(token) {
  //   console.log("this is the token", token)
  //   const self = this

  //   return new Promise((resolve, reject) => {
  //     // define callback
  //     const cb = (err, res) => {
  //       console.log("err", err, "res", res)
  //       err ? reject(err) : resolve(res.toObject())
  //     }

  //     let arg2, arg3
  //     const arg1 = new JWTReq()
  //     arg1.setJwt(token)

  //     if (process.server) {
  //       arg2 = cb
  //       arg3 = undefined
  //     } else {
  //       arg2 = {}
  //       arg3 = cb
  //     }

  //     self.client.jWT(arg1, arg2, arg3)
  //   })
  // }
}
